<div class="pt-2">
  @if (largeView) {
    <ul class="nav nav-tabs" id="holPMTab" role="tablist">
      @for (tab of tabNames | keyvalue; track tab) {
        <li class="nav-item" (click)="changeTab(tab.value)">
          <a
            class="nav-link"
            [ngClass]="selectedTab === tab.value ? 'active' : ''"
            >{{ tab.value }}</a
          >
        </li>
      }
    </ul>
  } @else {
    <div class="mb-2">
      <select
        class="form-select form-select-lg"
        [ngModel]="selectedTab"
        (change)="selectDropDown($event)"
      >
        @for (tab of tabNames | keyvalue; track tab) {
          <option [value]="tab.value">
            {{ tab.value }}
          </option>
        }
      </select>
    </div>
  }
  @if (selectedTab === pinnedMessageTab) {
    <gtapp-pinned-message></gtapp-pinned-message>
  } @else {
    <gtapp-gt-table
      [desktopTableBackendData]="HOLDataList"
      [desktopTableDetails]="tableDetailHOL"
      [otherParams]="otherParamsHOL"
      (searchColumn)="searchColumnHOL($event)"
      (sortColumn)="sortColumnHOL($event)"
      (paginationChange)="onChangePaginationHOL($event)"
      (rowClick)="onRowClick($event)"
    >
    </gtapp-gt-table>
    @if (groupUserCount > 1) {
      <div class="mt-1 mx-1">
        <div class="fixed-add-btn">
          <button
            class="btn btn-lg w-100"
            [routerLink]="['/add-hand-over-log']"
            [ngClass]="draftedHOLExists ? 'btn-success' : 'btn-primary'"
          >
            @if (draftedHOLExists) {
              <span>
                <span>
                  <i class="fa-solid fa-plus"></i>
                </span>
              </span>
            } @else {
              <span><i class="fa-solid fa-plus"></i></span>
            }
          </button>
        </div>
      </div>
    }
  }
</div>
